import React, { useState, useEffect } from "react";
import {
  Stethoscope,
  ShieldCheck,
  User,
  Lock,
  Mail,
  Activity,
  Eye,
  EyeOff,
  Building,
  Fingerprint,
  CheckCircle2,
  AlertCircle,
  Moon,
  Sun,
  ArrowRight,
  KeyRound,
  Award,
  LogOut,
  RefreshCw,
  X,
} from "lucide-react";
import { Alert } from "antd";
import { login, getNomNegocio } from "./Services/LoginServices";
import moment from "moment/moment";
import { confApp } from "../CONF_APP";

export const Home = () => {
  // Navigation & Auth state
  const [userRole, setUserRole] = useState("doctor"); // 'doctor', 'patient', 'admin'
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

  const [codNegocio, setCodNegocio] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);

  // UI state
  const [darkMode, setDarkMode] = useState(false);
  const [activeTab, setActiveTab] = useState("login"); // 'login' or 'biometric'
  const [biometricScanning, setBiometricScanning] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const [validationError, setValidationError] = useState("");

  // Form field focus tracking for UX highlights
  const [focusedInput, setFocusedInput] = useState("");
  

  const roleConfig = {
    doctor: {
      title: "Médico / Especialista",
      idLabel: "Correo Electrónico o Cédula Prof.",
      placeholder: "Correo / Usuario",
      demoEmail: "dr.rodriguez@consultoriodigital.com",
      demoPass: "medico2026*",
      name: "Dr. Alejandro Rodríguez",
      specialty: "Cardiología Clínica",
      badge: "Cédula: 7483921",
    },
    admin: {
      title: "Asistente / Admin",
      idLabel: "Usuario o Correo Institucional",
      placeholder: "Usuario / recepcion@consultorio.com",
      demoEmail: "asistente.recepcion@consultorio.com",
      demoPass: "adminAccess2026",
      name: "Lic. Sofia Mendoza",
      specialty: "Coordinación Médica",
      badge: "Acceso Operativo",
    },
  };

  const onClose = (e) => {
    console.log(e, "Cerrado...");
  };

  const setCookie = (name, value, hours) => {
    document.cookie = `${name}=${value};`;
    document.cookie = `expira=${moment().add(hours, "h").format()};`;
    document.cookie = `sessionID=${crypto.randomUUID()};`;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setValidationError("");

    try {
      setIsLoading(true);
      const data = {
        codNegocio: codNegocio,
        name: email,
        password: password,
        role: userRole
      };

      await login(data)
        .then((res) => {
          if (res.data === 0) {
            setIsLoading(false);
            setValidationError(
              "Los datos de inicio de sesión, no son correctos.",
            );
            return;
          }

          if (res.data === -1) {
            setIsLoading(false);
            setValidationError("El usuario se encuentra inactivo.");
            return;
          }

          const auth = {
            id: res.data.id,
            idUser: res.data.idUser,
            idMedico: res.data.idMedico,
            idMedicoLab: res.data.idMedicoLab,
            medico: res.data.medico,
            consultorio: res.data.consultorio,
            nombre: res.data.nombre,
            sesionIni: new Date().toISOString(),
            fecha: res.data.fecha,
            confApp: res.data.confApp,
            esMedicoLab: res.data.esMedicoLab,
            perfil: res.data.perfil,
          };

          localStorage.setItem("token", res.data.token);
          localStorage.setItem("auth", JSON.stringify(auth));
          var userUniq = `${res.data.id}${res.data.idUser}`;
          setCookie("user", userUniq, 16);
          setIsLoading(false);
          window.location = `/#/Home/Dashboard`;
        })
        .catch((err) => {
          setIsLoading(false);
          setValidationError(err.response.data);
          console.error(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleLogin = (e) => {
    e?.preventDefault();
    setValidationError("");

    if (!email.trim() || !password.trim() || !codNegocio.trim()) {
      setValidationError(
        "Por favor, ingresa tus credenciales completas para continuar.",
      );
      return;
    }

    setIsLoading(true);
  };

  const handleSendResetLink = (e) => {
    e.preventDefault();
    if (!forgotEmail) return;
    setResetSent(true);
    setTimeout(() => {
      // Auto close after success
      setTimeout(() => {
        setShowForgotPasswordModal(false);
        setResetSent(false);
        setForgotEmail("");
      }, 2500);
    }, 1000);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ESTE CODIGO NO ES FUNCIONAL YA QUE SOLO FUNCIONA DE EJEMPLO
  if (isLoggedIn && loggedInUser) {
    return (
      <div
        className={`min-h-screen ${darkMode ? "bg-slate-900 text-slate-100" : "bg-slate-50 text-slate-800"} transition-colors duration-300 font-sans`}
      >
        {/* Top Header */}
        <header
          className={`${darkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"} border-b px-6 py-4 flex justify-between items-center shadow-sm`}
        >
          <div className="flex items-center gap-3">
            <div className="bg-gradient-to-tr from-teal-500 to-blue-600 p-2.5 rounded-xl text-white shadow-md shadow-teal-500/20">
              <Stethoscope className="w-6 h-6" />
            </div>
            <div>
              <h1 className="font-bold text-lg tracking-tight flex items-center gap-2">
                Consultorio Digital{" "}
                <span className="text-xs bg-teal-500/10 text-teal-600 font-semibold px-2 py-0.5 rounded-full border border-teal-500/20">
                  v3.4 En Vivo
                </span>
              </h1>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                {loggedInUser.branch}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="p-2 rounded-lg bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600 transition"
              title="Cambiar Tema"
            >
              {darkMode ? (
                <Sun className="w-5 h-5" />
              ) : (
                <Moon className="w-5 h-5" />
              )}
            </button>
            <div className="h-6 w-px bg-slate-200 dark:bg-slate-700"></div>
            <button
              onClick={() => setIsLoggedIn(false)}
              className="flex items-center gap-2 text-sm font-medium text-rose-600 hover:text-rose-700 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/40 px-3.5 py-2 rounded-lg border border-rose-200 dark:border-rose-900 transition"
            >
              <LogOut className="w-4 h-4" /> Cerrar Sesión
            </button>
          </div>
        </header>
      </div>
    );
  }

  return (
    <div
      className={`min-h-screen ${darkMode ? "bg-slate-950 text-slate-100" : "bg-slate-100 text-slate-800"} transition-colors duration-300 font-sans flex flex-col justify-between selection:bg-teal-500 selection:text-white`}
    >
      {/* Top Header Bar */}
      <header className="w-full max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-gradient-to-tr from-teal-500 to-blue-600 p-2.5 rounded-xl text-white shadow-md shadow-teal-500/20 flex items-center justify-center">
            <Stethoscope className="w-6 h-6" />
          </div>
          <div>
            <span className="font-bold text-xl tracking-tight bg-gradient-to-r from-teal-600 to-blue-600 dark:from-teal-400 dark:to-blue-400 bg-clip-text text-transparent">
              Consultorio Digital
            </span>
            <span className="hidden sm:inline-block text-xs text-slate-500 dark:text-slate-400 ml-2 border-l border-slate-300 dark:border-slate-700 pl-2">
              Plataforma Médica Integral
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setDarkMode(!darkMode)}
            className={`p-2.5 rounded-xl border ${darkMode ? "bg-slate-900 border-slate-800 text-amber-400 hover:bg-slate-800" : "bg-white border-slate-200 text-slate-600 hover:bg-slate-50"} transition-all shadow-sm`}
            title="Cambiar modo"
          >
            {darkMode ? (
              <Sun className="w-4 h-4" />
            ) : (
              <Moon className="w-4 h-4" />
            )}
          </button>

          {/* <div className="hidden md:flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 bg-slate-200/50 dark:bg-slate-900/50 px-3 py-1.5 rounded-lg border border-slate-300/50 dark:border-slate-800">
            <PhoneCall className="w-3.5 h-3.5 text-teal-500"  />
            <span>
              Soporte Médico: <strong>800-MED-HELP</strong>
            </span>
          </div> */}
        </div>
      </header>

      {/* Main Split Layout */}
      {isMobile ? (
        <div className="flex flex-col justify-center" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
          <div
            className={`${darkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200/80"} border rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl transition-all`}
          >
            {/* Branch Selector */}
            {/* <div className="mb-2 pb-5 border-b border-slate-200 dark:border-slate-800 justify-center">
              <label className="text-lg font-semibold text-slate-500 dark:text-slate-400 uppercase 
								tracking-wider flex items-center gap-1.5">
                  <Building className="w-4.5 h-4.5 text-teal-500" />
                  Inicio de Sesión
                </label>
              {/* <select
                  value={selectedBranch}
                  onChange={(e) => setSelectedBranch(e.target.value)}
                  className={`w-full px-3.5 py-2.5 rounded-xl border ${darkMode ? "bg-slate-800 border-slate-700 text-slate-200" : "bg-slate-50 border-slate-200 text-slate-700"} text-sm font-medium focus:ring-2 focus:ring-teal-500 focus:outline-none transition`}
                >
                  {branches.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name} — {branch.address}
                    </option>
                  ))}
                </select>
            </div> */}

            {/* Role Selection Tabs */}
            <div className="mb-6">
              <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 mb-2 uppercase tracking-wider">
                Tipo de Acceso
              </label>
              <div className="grid grid-cols-2 gap-2 p-1.5 bg-slate-100 dark:bg-slate-800 rounded-2xl">
                {Object.keys(roleConfig).map((role) => (
                  <button
                    key={role}
                    type="button"
                    onClick={() => {
                      setUserRole(role);
                      setValidationError("");
                    }}
                    className={`py-2.5 px-3 rounded-xl text-xs font-semibold transition-all flex flex-col sm:flex-row items-center justify-center gap-1.5 ${
                      userRole === role
                        ? "bg-white dark:bg-slate-700 text-teal-600 dark:text-teal-300 shadow-md"
                        : "text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200"
                    }`}
                  >
                    {role === "doctor" && <Stethoscope className="w-4 h-4" />}
                    {role === "patient" && <User className="w-4 h-4" />}
                    {role === "admin" && <Building className="w-4 h-4" />}
                    <span>
                      {role === "doctor"
                        ? "Médico"
                        : role === "patient"
                          ? "Paciente"
                          : "Asistente"}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            {/* Login Method Toggle (Standard / Biometric) */}
            <div className="flex border-b border-slate-200 dark:border-slate-800 mb-6">
              <button
                onClick={() => setActiveTab("login")}
                className={`pb-3 text-sm font-semibold border-b-2 transition-all mr-6 flex items-center gap-2 ${
                  activeTab === "login"
                    ? "border-teal-500 text-teal-600 dark:text-teal-400"
                    : "border-transparent text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
                }`}
              >
                <KeyRound className="w-4 h-4" /> Contraseña / Credenciales
              </button>
              {/* <button
                  onClick={() => setActiveTab("biometric")}
                  className={`pb-3 text-sm font-semibold border-b-2 transition-all flex items-center gap-2 ${
                    activeTab === "biometric"
                      ? "border-teal-500 text-teal-600 dark:text-teal-400"
                      : "border-transparent text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
                  }`}
                >
                  <Fingerprint className="w-4 h-4" /> Biometría / FaceID
                </button> */}
            </div>

            {/* ERROR BANNER */}
            {validationError && (
              <>
                <Alert
                  title={validationError}
                  type="error"
                  closable={{
                    closeIcon: true,
                    onClose,
                    "aria-label": "close",
                  }}
                />
                <br></br>
              </>
            )}

            {/* TAB 1: Standard Password Form */}
            {activeTab === "login" ? (
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* CODIGO DE */}
                <div>
                  <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
                    Código de Negocio
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                      <Building className="w-4 h-4" />
                    </div>
                    <input
                      type="text"
                      value={codNegocio}
                      onChange={(e) => setCodNegocio(e.target.value)}
                      onFocus={() => setFocusedInput("codNegocio")}
                      onBlur={() => setFocusedInput("")}
                      placeholder={"Código de Negocio"}
                      className={`w-full pl-10 pr-4 py-3 text-sm rounded-xl border transition-all ${
                        darkMode
                          ? "bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500 focus:border-teal-500"
                          : "bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400 focus:border-teal-500"
                      } ${focusedInput === "email" ? "ring-2 ring-teal-500/20" : ""}`}
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                </div>
                {/* Email / ID Input */}

                <div>
                  <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
                    {roleConfig[userRole].idLabel}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                      <Mail className="w-4 h-4" />
                    </div>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onFocus={() => setFocusedInput("email")}
                      onBlur={() => setFocusedInput("")}
                      placeholder={roleConfig[userRole].placeholder}
                      className={`w-full pl-10 pr-4 py-3 text-sm rounded-xl border transition-all ${
                        darkMode
                          ? "bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500 focus:border-teal-500"
                          : "bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400 focus:border-teal-500"
                      } ${focusedInput === "email" ? "ring-2 ring-teal-500/20" : ""}`}
                    />
                  </div>
                </div>

                {/* Password Input */}
                <div>
                  <div className="flex items-center justify-between mb-1.5">
                    <label className="text-xs font-semibold text-slate-600 dark:text-slate-300">
                      Contraseña
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowForgotPasswordModal(true)}
                      className="text-xs font-medium text-teal-600 dark:text-teal-400 hover:underline"
                    >
                      ¿Olvidaste tu contraseña?
                    </button>
                  </div>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                      <Lock className="w-4 h-4" />
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onFocus={() => setFocusedInput("password")}
                      onBlur={() => setFocusedInput("")}
                      placeholder="••••••••••••"
                      className={`w-full pl-10 pr-10 py-3 text-sm rounded-xl border transition-all ${
                        darkMode
                          ? "bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500 focus:border-teal-500"
                          : "bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400 focus:border-teal-500"
                      } ${focusedInput === "password" ? "ring-2 ring-teal-500/20" : ""}`}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                    >
                      {showPassword ? (
                        <EyeOff className="w-4 h-4" />
                      ) : (
                        <Eye className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Remember Me */}
                <div className="flex items-center justify-between pt-1">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      className="w-4 h-4 rounded text-teal-600 focus:ring-teal-500 border-slate-300 dark:border-slate-700"
                    />
                    <span className="text-xs text-slate-600 dark:text-slate-400">
                      Recordar mi sesión en este equipo
                    </span>
                  </label>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full mt-2 py-3.5 px-4 bg-gradient-to-r from-teal-500 to-blue-600 hover:from-teal-600 hover:to-blue-700 text-white font-semibold rounded-xl shadow-lg shadow-teal-500/25 transition-all transform active:scale-[0.99] flex items-center justify-center gap-2 text-sm disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isLoading ? (
                    <>
                      <RefreshCw className="w-4 h-4 animate-spin" /> Verificando
                      Credenciales...
                    </>
                  ) : (
                    <>
                      Iniciar Sesión Segura <ArrowRight className="w-4 h-4" />
                    </>
                  )}
                </button>
              </form>
            ) : (
              <div className="py-6 text-center space-y-5">
                <div className="relative inline-block">
                  <div
                    className={`p-6 rounded-full ${biometricScanning ? "bg-teal-500/20 animate-pulse" : "bg-slate-100 dark:bg-slate-800"} transition-all`}
                  >
                    <Fingerprint
                      className={`w-16 h-16 ${biometricScanning ? "text-teal-500" : "text-slate-400"}`}
                    />
                  </div>
                </div>

                <div>
                  <h3 className="text-base font-bold">
                    Autenticación Biométrica
                  </h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 max-w-xs mx-auto">
                    Ingresa escaneando tu Huella Digital o mediante
                    reconocimiento Facial (FaceID registrado).
                  </p>
                </div>
              </div>
            )}

            {/* DEMO ACCESIBILITY BUTTONS */}
            {/* <div className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-800">
                <p className="text-xs text-center font-semibold text-slate-400 uppercase tracking-wider mb-3">
                  Prueba Rápida (Credenciales Demo)
                </p>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    type="button"
                    onClick={() => handleDemoFill("doctor")}
                    className="px-3 py-2 rounded-xl text-xs font-medium border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 hover:bg-teal-50 dark:hover:bg-teal-950/30 hover:border-teal-300 text-slate-700 dark:text-slate-300 transition flex items-center justify-center gap-1.5"
                  >
                    <Stethoscope className="w-3.5 h-3.5 text-teal-500" /> Demo
                    Médico
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDemoFill("patient")}
                    className="px-3 py-2 rounded-xl text-xs font-medium border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 hover:bg-blue-50 dark:hover:bg-blue-950/30 hover:border-blue-300 text-slate-700 dark:text-slate-300 transition flex items-center justify-center gap-1.5"
                  >
                    <User className="w-3.5 h-3.5 text-blue-500" /> Demo Paciente
                  </button>
                </div>
              </div> */}
          </div>
        </div>
      ) : (
        <main className="flex-1 max-w-7xl w-full mx-auto p-4 sm:p-6 lg:p-8 flex items-center justify-center">
          <div className="w-full grid lg:grid-cols-12 gap-8 items-stretch min-h-[620px]">
            {/* LEFT COLUMN: Hero & Features Banner */}
            <div className="lg:col-span-5 bg-gradient-to-br from-teal-600 via-teal-700 to-blue-800 rounded-3xl p-8 lg:p-10 text-white flex flex-col justify-between shadow-2xl relative overflow-hidden group">
              {/* Subtle background graphics */}
              <div className="absolute -right-20 -top-20 w-80 h-80 bg-white/10 rounded-full blur-3xl pointer-events-none"></div>
              <div className="absolute -left-20 -bottom-20 w-80 h-80 bg-blue-500/20 rounded-full blur-2xl pointer-events-none"></div>
              <Activity className="absolute top-8 right-8 w-32 h-32 text-white/5 pointer-events-none" />

              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 border border-white/20 text-teal-100 text-xs font-medium backdrop-blur-md mb-6">
                  <ShieldCheck className="w-4 h-4 text-teal-300" />
                  Cumplimiento Normativo ISO 27001
                </div>

                <h2 className="text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight">
                  Gestión Médica Inteligente y Segura
                </h2>
                <p className="mt-4 text-teal-100 text-sm lg:text-base leading-relaxed">
                  Accede al expediente clínico electrónico, agenda citas
                  presenciales, agenda semanal, notas de evolución, laboratorios y más...
                </p>

                {/* Interactive Widget Feature Card */}
                <img src="/Images/Login.jpg" className="mt-2 bg-white/10 backdrop-blur-md rounded-2xl p-1 border border-white/15 shadow-inner" />
              </div>

              {/* Bottom Testimonial / Security Footer */}
              <div className="relative z-10 mt-8 pt-6 border-t border-white/15 flex items-center justify-between text-xs text-teal-100">
                <div className="flex items-center gap-2">
                  <Award className="w-4 h-4 text-amber-300" />
                  <span>En Proceso de Certificación NOM-024-SSA3-2012</span>
                </div>
                <span className="opacity-80">{confApp.VERSION}</span>
              </div>
            </div>

            {/* RIGHT COLUMN: Interactive Login Form Panel */}
            <div className="lg:col-span-7 flex flex-col justify-center">
              <div
                className={`${darkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200/80"} border rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl transition-all`}
              >
                {/* Branch Selector */}
                <div className="mb-6 pb-5 border-b border-slate-200 dark:border-slate-800">
                  {/* <label className="block text-lg font-semibold text-slate-500 dark:text-slate-400 mb-2 uppercase 
								tracking-wider flex items-center gap-1.5">
                  <Building className="w-4.5 h-4.5 text-teal-500" />
                  CONSULTORIO DIGITAL - INICIO DE SESIÓN
                </label> */}
                  {/* <select
                  value={selectedBranch}
                  onChange={(e) => setSelectedBranch(e.target.value)}
                  className={`w-full px-3.5 py-2.5 rounded-xl border ${darkMode ? "bg-slate-800 border-slate-700 text-slate-200" : "bg-slate-50 border-slate-200 text-slate-700"} text-sm font-medium focus:ring-2 focus:ring-teal-500 focus:outline-none transition`}
                >
                  {branches.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name} — {branch.address}
                    </option>
                  ))}
                </select> */}
                </div>

                {/* Role Selection Tabs */}
                <div className="mb-6">
                  <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 mb-2 uppercase tracking-wider">
                    Tipo de Acceso
                  </label>
                  <div className="grid grid-cols-2 gap-2 p-1.5 bg-slate-100 dark:bg-slate-800 rounded-2xl">
                    {Object.keys(roleConfig).map((role) => (
                      <button
                        key={role}
                        type="button"
                        onClick={() => {
                          setUserRole(role);
                          setValidationError("");
                        }}
                        className={`py-2.5 px-3 rounded-xl text-xs font-semibold transition-all flex flex-col sm:flex-row items-center justify-center gap-1.5 ${
                          userRole === role
                            ? "bg-white dark:bg-slate-700 text-teal-600 dark:text-teal-300 shadow-md"
                            : "text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200"
                        }`}
                      >
                        {role === "doctor" && (
                          <Stethoscope className="w-4 h-4" />
                        )}
                        {role === "patient" && <User className="w-4 h-4" />}
                        {role === "Admin" && <Building className="w-4 h-4" />}
                        <span>
                          {role === "doctor"
                            ? "Médico"
                            : role === "patient"
                              ? "Paciente"
                              : "Asistente"}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Login Method Toggle (Standard / Biometric) */}
                <div className="flex border-b border-slate-200 dark:border-slate-800 mb-6">
                  <button
                    onClick={() => setActiveTab("login")}
                    className={`pb-3 text-sm font-semibold border-b-2 transition-all mr-6 flex items-center gap-2 ${
                      activeTab === "login"
                        ? "border-teal-500 text-teal-600 dark:text-teal-400"
                        : "border-transparent text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
                    }`}
                  >
                    <KeyRound className="w-4 h-4" /> Contraseña / Credenciales
                  </button>
                  {/* <button
                  onClick={() => setActiveTab("biometric")}
                  className={`pb-3 text-sm font-semibold border-b-2 transition-all flex items-center gap-2 ${
                    activeTab === "biometric"
                      ? "border-teal-500 text-teal-600 dark:text-teal-400"
                      : "border-transparent text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
                  }`}
                >
                  <Fingerprint className="w-4 h-4" /> Biometría / FaceID
                </button> */}
                </div>

                {/* ERROR BANNER */}
                {validationError && (
                  <>
                    <Alert
                      title={validationError}
                      type="error"
                      closable={{
                        closeIcon: true,
                        onClose,
                        "aria-label": "close",
                      }}
                    />
                    <br></br>
                  </>
                )}

                {/* TAB 1: Standard Password Form */}
                {activeTab === "login" ? (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    {/* CODIGO DE */}
                    <div>
                      <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
                        Código de Negocio
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                          <Building className="w-4 h-4" />
                        </div>
                        <input
                          type="text"
                          value={codNegocio}
                          onChange={(e) => setCodNegocio(e.target.value)}
                          onFocus={() => setFocusedInput("codNegocio")}
                          onBlur={() => setFocusedInput("")}
                          placeholder={"Código de Negocio"}
                          className={`w-full pl-10 pr-4 py-3 text-sm rounded-xl border transition-all ${
                            darkMode
                              ? "bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500 focus:border-teal-500"
                              : "bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400 focus:border-teal-500"
                          } ${focusedInput === "email" ? "ring-2 ring-teal-500/20" : ""}`}
                          style={{ textTransform: "uppercase" }}
                        />
                      </div>
                    </div>
                    {/* Email / ID Input */}

                    <div>
                      <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
                        {roleConfig[userRole].idLabel}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                          <Mail className="w-4 h-4" />
                        </div>
                        <input
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onFocus={() => setFocusedInput("email")}
                          onBlur={() => setFocusedInput("")}
                          placeholder={roleConfig[userRole].placeholder}
                          className={`w-full pl-10 pr-4 py-3 text-sm rounded-xl border transition-all ${
                            darkMode
                              ? "bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500 focus:border-teal-500"
                              : "bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400 focus:border-teal-500"
                          } ${focusedInput === "email" ? "ring-2 ring-teal-500/20" : ""}`}
                        />
                      </div>
                    </div>

                    {/* Password Input */}
                    <div>
                      <div className="flex items-center justify-between mb-1.5">
                        <label className="text-xs font-semibold text-slate-600 dark:text-slate-300">
                          Contraseña
                        </label>
                        <button
                          type="button"
                          onClick={() => setShowForgotPasswordModal(true)}
                          className="text-xs font-medium text-teal-600 dark:text-teal-400 hover:underline"
                        >
                          ¿Olvidaste tu contraseña?
                        </button>
                      </div>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                          <Lock className="w-4 h-4" />
                        </div>
                        <input
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onFocus={() => setFocusedInput("password")}
                          onBlur={() => setFocusedInput("")}
                          placeholder="••••••••••••"
                          className={`w-full pl-10 pr-10 py-3 text-sm rounded-xl border transition-all ${
                            darkMode
                              ? "bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500 focus:border-teal-500"
                              : "bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400 focus:border-teal-500"
                          } ${focusedInput === "password" ? "ring-2 ring-teal-500/20" : ""}`}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                        >
                          {showPassword ? (
                            <EyeOff className="w-4 h-4" />
                          ) : (
                            <Eye className="w-4 h-4" />
                          )}
                        </button>
                      </div>
                    </div>

                    {/* Remember Me */}
                    <div className="flex items-center justify-between pt-1">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                          className="w-4 h-4 rounded text-teal-600 focus:ring-teal-500 border-slate-300 dark:border-slate-700"
                        />
                        <span className="text-xs text-slate-600 dark:text-slate-400">
                          Recordar mi sesión en este equipo
                        </span>
                      </label>
                    </div>

                    {/* Submit Button */}
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full mt-2 py-3.5 px-4 bg-gradient-to-r from-teal-500 to-blue-600 hover:from-teal-600 hover:to-blue-700 text-white font-semibold rounded-xl shadow-lg shadow-teal-500/25 transition-all transform active:scale-[0.99] flex items-center justify-center gap-2 text-sm disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {isLoading ? (
                        <>
                          <RefreshCw className="w-4 h-4 animate-spin" />{" "}
                          Verificando Credenciales...
                        </>
                      ) : (
                        <>
                          Iniciar Sesión Segura{" "}
                          <ArrowRight className="w-4 h-4" />
                        </>
                      )}
                    </button>
                  </form>
                ) : (
                  <div className="py-6 text-center space-y-5">
                    <div className="relative inline-block">
                      <div
                        className={`p-6 rounded-full ${biometricScanning ? "bg-teal-500/20 animate-pulse" : "bg-slate-100 dark:bg-slate-800"} transition-all`}
                      >
                        <Fingerprint
                          className={`w-16 h-16 ${biometricScanning ? "text-teal-500" : "text-slate-400"}`}
                        />
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-bold">
                        Autenticación Biométrica
                      </h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 max-w-xs mx-auto">
                        Ingresa escaneando tu Huella Digital o mediante
                        reconocimiento Facial (FaceID registrado).
                      </p>
                    </div>
                  </div>
                )}

                {/* DEMO ACCESIBILITY BUTTONS */}
                {/* <div className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-800">
                <p className="text-xs text-center font-semibold text-slate-400 uppercase tracking-wider mb-3">
                  Prueba Rápida (Credenciales Demo)
                </p>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    type="button"
                    onClick={() => handleDemoFill("doctor")}
                    className="px-3 py-2 rounded-xl text-xs font-medium border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 hover:bg-teal-50 dark:hover:bg-teal-950/30 hover:border-teal-300 text-slate-700 dark:text-slate-300 transition flex items-center justify-center gap-1.5"
                  >
                    <Stethoscope className="w-3.5 h-3.5 text-teal-500" /> Demo
                    Médico
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDemoFill("patient")}
                    className="px-3 py-2 rounded-xl text-xs font-medium border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 hover:bg-blue-50 dark:hover:bg-blue-950/30 hover:border-blue-300 text-slate-700 dark:text-slate-300 transition flex items-center justify-center gap-1.5"
                  >
                    <User className="w-3.5 h-3.5 text-blue-500" /> Demo Paciente
                  </button>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </main>
      )}

      {/* Footer */}
      <footer className="w-full max-w-7xl mx-auto px-6 py-4 text-center text-xs text-slate-400 dark:text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <ShieldCheck className="w-4 h-4 text-teal-500" />
          <span>
            © 2026 Consultorio Digital. Todos los derechos reservados a Grupo
            RADYXXA México
          </span>
        </div>
        <div className="flex gap-4">
          {/* <a href="#/AvisoPrivacidad" className="hover:underline">
            Aviso de Privacidad
          </a>
          <a href="#/TerminosServicio" className="hover:underline">
            Términos de Servicio
          </a> */}
          {/* <a href="#" className="hover:underline">
            Soporte Técnico
          </a> */}
        </div>
      </footer>

      {}
      {showForgotPasswordModal && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn">
          <div
            className={`${darkMode ? "bg-slate-900 border-slate-800 text-slate-100" : "bg-white border-slate-200 text-slate-800"} border rounded-2xl max-w-md w-full p-6 shadow-2xl relative`}
          >
            <button
              onClick={() => setShowForgotPasswordModal(false)}
              className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 bg-teal-50 dark:bg-teal-950/50 rounded-xl text-teal-600 dark:text-teal-400">
                <KeyRound className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-bold text-base">Recuperar Contraseña</h3>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Te enviaremos un código de restauración
                </p>
              </div>
            </div>

            {resetSent ? (
              <div className="py-6 text-center space-y-3">
                <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
                <p className="text-sm font-semibold text-emerald-600 dark:text-emerald-400">
                  ¡Correo enviado con éxito!
                </p>
                <p className="text-xs text-slate-500">
                  Revisa tu bandeja de entrada en <strong>{forgotEmail}</strong>{" "}
                  e ingresa el enlace enviado.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSendResetLink} className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
                    Correo electrónico asociado
                  </label>
                  <input
                    type="email"
                    required
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    placeholder="doctor@ejemplo.com"
                    className={`w-full px-3.5 py-2.5 text-sm rounded-xl border ${
                      darkMode
                        ? "bg-slate-800 border-slate-700"
                        : "bg-slate-50 border-slate-200"
                    } focus:outline-none focus:ring-2 focus:ring-teal-500`}
                  />
                </div>

                <div className="flex justify-end gap-2 pt-2">
                  <button
                    type="button"
                    onClick={() => setShowForgotPasswordModal(false)}
                    className="px-4 py-2 rounded-xl text-xs font-semibold border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-xl text-xs font-semibold transition"
                  >
                    Enviar Instrucciones
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
